import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { Button, Tooltip } from "@mui/material";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import DashboardIcon from "@mui/icons-material/Dashboard";
import SearchIcon from "@mui/icons-material/Search";
import ImageIcon from "@mui/icons-material/Image";
// import PaymentsIcon from "@mui/icons-material/Payments";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import ArticleIcon from "@mui/icons-material/Article";
import PrintIcon from "@mui/icons-material/Print";
import DownloadIcon from "@mui/icons-material/Download";

import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
// import UserDashboard from "../components/UserDashboard/UserDashboard";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import adminLogo from "../../assets/ukpsc logo.png";
import "../../styles/Layout/Admin_Styles/_AdminDashboard.scss";
// import AdminSearchDetails from "../components/AdminSearchDetails/AdminSearchDetails";
import { Stack } from "@mui/material";
// import DownloadData from "../components/DownloadData/DownloadData";
// import Degree from "../components/Degree/Degree";
// import Payment from "../components/Payment/Payment";
// import PrintApplication from "../components/PrintApplication/PrintApplication";
import { Outlet, useNavigate } from "react-router-dom";
import { paths } from "../../utils/path";
import { AuthContext } from "../../context/AuthContext";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

const sideBar = [
  {
    title: "Dashboard",
    icon: <DashboardIcon className="icon-group-color-green" />,
    path: `/${paths?.admin?.user?.dashboard}`,
    iconTitle: "Dashboard",
  },
  {
    title: "Candidates",
    icon: <SearchIcon className="icon-group-color-green" />,
    path: `/${paths?.admin?.user?.candidates}`,
    iconTitle: "Candidates",
  },
  {
    title: "Print Payment Slip",
    icon: <PrintIcon className="icon-group-color-green" />,
    path: `/${paths?.admin?.user?.printView}`,
    iconTitle: "Print Payment Slip",
  },
  {
    title: "Re-Upload Image",
    icon: <ImageIcon className="icon-group-color-green" />,
    path: `/${paths?.admin?.user?.reUploadImage}`,
    iconTitle: "Re-Upload Image",
  },
  {
    title: "Download Data",
    icon: <DownloadIcon className="icon-group-color-green" />,
    path: `/${paths?.admin?.user?.downloadData}`,
    iconTitle: "Download Data",
  },
  // {
  //   title: "Payment",
  //   icon: <PaymentsIcon className="icon-group-color-green" />,
  //   path: `/${paths?.admin?.user?.payment}`,
  //   iconTitle: "Payment",
  // },
  {
    title: "Degree",
    icon: <WorkspacePremiumIcon className="icon-group-color-green" />,
    path: `/${paths?.admin?.user?.degree}`,
    iconTitle: "Degree",
  },
  {
    title: "Subject",
    icon: <ArticleIcon className="icon-group-color-green" />,
    path: `/${paths?.admin?.user?.subject}`,
    iconTitle: "Subject",
  },
];

const AdminDashboardLayout = () => {
  const navigate = useNavigate();
  const { deleteAuthState } = React.useContext(AuthContext);
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  // const [listOpen, setListOpen] = React.useState(0);

  const [activePath, setActivePath] = React.useState(
    window.location.pathname.split("/")
  );

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const logout = () => {
    deleteAuthState("admin-token");
    navigate(`${paths?.admin?.commonPoint}/${paths?.admin?.login}`);
  };

  // const handleClick = (index) => {
  //     setListOpen(index);
  //     handleDrawerOpen();
  // };

  return (
    <Box sx={{ display: "flex" }} className="admin-dashboard">
      <CssBaseline />
      <AppBar position="fixed" open={open} className="admin-dashboard--navbar">
        <Toolbar>
          <Tooltip title="Open">
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              sx={{
                marginRight: 5,
                ...(open && { opacity: 0 }),
              }}
            >
              <MenuIcon />
            </IconButton>
          </Tooltip>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            className="admin-dashboard--navbar-content"
          >
            <div>
              <img src={adminLogo} className="adminLogo" alt="ukpsc-logo" />
            </div>
            <div className="admin-header">
              <h2>Executive Officer and Tax & Revenue Inspector Exam-2023</h2>
            </div>
            <div>
              <Button
                variant="text"
                startIcon={<PowerSettingsNewIcon />}
                onClick={logout}
              >
                Logout
              </Button>
            </div>
          </Stack>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        open={open}
        className="admin-dashboard--sidebar"
      >
        <DrawerHeader>
          <Tooltip title="Close">
            <IconButton onClick={handleDrawerClose}>
              {theme.direction === "rtl" ? (
                <ChevronRightIcon />
              ) : (
                <ChevronLeftIcon />
              )}
            </IconButton>
          </Tooltip>
        </DrawerHeader>
        <Divider />
        <List>
          {sideBar.map((item, index) => (
            <ListItem
              key={item?.title}
              disablePadding
              sx={{ display: "block" }}
              className={
                item?.path === `/${activePath[activePath.length - 1]}`
                  ? "active-list"
                  : "hover-style"
              }
              onClick={() => {
                // handleClick(index)
                setActivePath(item?.path?.split("/"));
                window.scrollTo(0, 0);
                navigate(
                  `${paths?.admin?.commonPoint}/${paths?.admin?.user?.commonPoint}${item?.path}`
                );
              }}
            >
              <ListItemButton
                sx={{
                  minHeight: 48,
                  justifyContent: open ? "initial" : "center",
                  px: 2.5,
                }}
              >
                <ListItemIcon
                  sx={{
                    minWidth: 0,
                    mr: open ? 3 : "auto",
                    justifyContent: "center",
                  }}
                >
                  <Tooltip title={item?.iconTitle}>{item?.icon}</Tooltip>
                </ListItemIcon>
                <ListItemText
                  primary={item?.title}
                  sx={{ opacity: open ? 1 : 0 }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Drawer>
      <Box
        component="main"
        sx={{ flexGrow: 1, p: 3 }}
        className="admin-dashboard--content-box"
      >
        <DrawerHeader />
        {/* {JSON.stringify(activePath)} */}
        <Outlet />
      </Box>
    </Box>
  );
};

export default AdminDashboardLayout;
